/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInputNumber = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M3 5H2v14h20V5h-1zm1 12V7h16v10zm5.84-2.84V15h3.785v-1.016h-2.16l.808-.888c.33-.368.592-.683.784-.944.197-.267.338-.507.424-.72.085-.213.128-.427.128-.64 0-.523-.17-.925-.512-1.208-.342-.283-.822-.424-1.44-.424-.278 0-.563.037-.856.112-.288.07-.558.168-.808.296v1.072c.55-.293 1.04-.44 1.472-.44.613 0 .92.243.92.728a.924.924 0 0 1-.096.384 2.7 2.7 0 0 1-.336.496c-.155.192-.373.443-.656.752zm-2.512-3.4V15h1.256V9.264h-.888L6 10.472v.736z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgInputNumber as InputNumber };
